import { render, staticRenderFns } from "./AlertaVencimento.vue?vue&type=template&id=7b9874c1"
import script from "./AlertaVencimento.vue?vue&type=script&lang=js"
export * from "./AlertaVencimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports